export { AdditionalInfo, AdditionalInfoWrapper } from './AdditionalInfo.styled';
